import { request } from '@h3/request';
import { H3 } from '@h3/types';

/**
 * 获取异步任务列表
 * @param sceneCodes 需要的任务场景编码，不传则返回所有任务
 * @returns 异步任务列表
 */
export function getTaskList(sceneCodes?: H3.AsyncTask.TaskScene[], taskIds?: string[]) {
    return request<H3.Http.Response.H3Response<H3.AsyncTask.Response.TGetTaskList[]>>(
        '/v1/toolkit/asynctask/visibletasks',
        {
            method: H3.Http.MethodType.POST,
            data: {
                sceneCodes,
                taskIds,
            },
        },
    );
}

/**
 * 设置指定任务不显示
 * @param taskIds 任务id列表
 * @returns 是否隐藏成功
 */
export function disVisibleTask(taskIds: string[]) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/toolkit/asynctask/tasks/setdisvisible', {
        method: H3.Http.MethodType.POST,
        data: {
            taskIds,
        },
    });
}

/**
 * 查询给定任务的进度
 * @param taskIds 任务id列表
 * @returns 任务id到任务进度数据的映射
 */
export function getProgress(taskIds: string) {
    return request<H3.Http.Response.H3Response<Record<string, H3.AsyncTask.Response.TGetTaskProgress>>>(
        '/v1/asynctask/progress',
        {
            method: H3.Http.MethodType.POST,
            data: {
                taskIds,
            },
        },
    );
}

/**
 * 获取公式型控件执行记录
 * @param taskId 异步任务id
 * @param successful 执行成功与否筛选，null表示不筛选
 * @param failType 执行失败类型筛选，null表示不筛选
 * @param pageIndex 分页索引
 * @param pageSize 分页大小
 * @returns 公式型控件执行记录
 */
export function getFormulaChangedExeRecord(
    taskId: string,
    successful: boolean | null,
    failType: 'fail' | 'abort' | null,
    pageIndex: number,
    pageSize: number,
) {
    return request<H3.Http.Response.H3Response<H3.AsyncTask.Response.TGetFormulaChangedExeRecord>>(
        '/v1/toolkit/bizlog/asynctask/formulachanged',
        {
            method: H3.Http.MethodType.POST,
            data: {
                taskId,
                successful,
                failType,
                pageIndex,
                pageSize,
            },
        },
    );
}

/**
 * 获取公式型控件执行记录
 * @param taskId 异步任务id
 * @param successful 执行成功与否筛选，null表示不筛选
 * @param failType 执行失败类型筛选，null表示不筛选
 * @param pageIndex 分页索引
 * @param pageSize 分页大小
 * @returns 公式型控件执行记录
 */
export function getRollupChangedExeRecord(
    asyncTaskId: string,
    pageIndex: number,
    limit: number,
    isSuccess: boolean | null,
) {
    return request<H3.Http.Response.H3Response<H3.AsyncTask.Response.TGetRollupChangedExeRecord>>(
        '/v1/toolkit/bizlog/rollup/recompute/detail',
        {
            method: H3.Http.MethodType.POST,
            data: {
                asyncTaskId,
                isSuccess,
                offset: pageIndex * limit,
                limit,
            },
        },
    );
}

/**
 * 取消task
 * @param asyncTaskId
 * @returns
 */
export function cancelTask(asyncTaskId: string, sceneCode: string) {
    return request<H3.Http.Response.H3Response<H3.AsyncTask.Response.TGetRollupChangedExeRecord>>(
        '/v1/toolkit/asynctask/canceltask',
        {
            method: H3.Http.MethodType.POST,
            data: {
                taskId: asyncTaskId,
                SceneCode: sceneCode,
            },
        },
    );
}

/**
 * 汇总控件添加重算任务
 * @param asyncTaskId
 * @returns
 */
export function addRollupRecomputeTask(schemaCode: string, propertyName: string, rollupRecomputeDateTime?: string) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/form/rollup/rolluprecomputetask', {
        method: H3.Http.MethodType.POST,
        data: {
            schemaCode,
            propertyName,
            rollupRecomputeDateTime,
        },
    });
}

/**
 * 汇总控件添加重算任务
 * @param asyncTaskId
 * @returns
 */
export function addRollupRecomputeTasks(
    tasks: Array<{ schemaCode: string; propertyName: string }>,
    rollupRecomputeDateTime?: string,
) {
    return request<H3.Http.Response.H3Response<boolean>>('/v1/form/rollup/rolluprecomputetasks', {
        method: H3.Http.MethodType.POST,
        data: {
            recomputeTasks: tasks,
            rollupRecomputeDateTime,
        },
    });
}

/**
 * 获取定时任务列表
 * @param appCode 应用编码
 * @param sceneCodes 需要的任务场景编码，不传则返回所有任务
 * @returns 异步任务列表
 */
export function getCronVisibleTask(appCode: string, sceneCodes: H3.AsyncTask.TaskScene[]) {
    return request<H3.Http.Response.H3Response<H3.AsyncTask.Response.TGetTaskList[]>>(
        '/v1/toolkit/asynctask/cronvisibletasks',
        {
            method: H3.Http.MethodType.POST,
            data: {
                appCode,
                sceneCodes,
            },
        },
    );
}
